import React from 'react';
import { FieldValues } from 'react-hook-form';

import { QuestionSize } from '../constants';
import { QuestionTextAreaProps } from '../types';
import QuestionTemplate from '.';
import TextArea from 'components/Inputs/TextArea';

function QuestionTextArea<T extends FieldValues>({
  children,
  control,
  disabled,
  id,
  label,
  name,
  readOnly,
  size = QuestionSize.MEDIUM,
  ...props
}: QuestionTextAreaProps<T>) {
  return (
    <QuestionTemplate<T>
      control={control}
      disabled={disabled}
      id={id}
      label={label}
      name={name}
      readOnly={readOnly}
      size={size}>
      {({ invalid, onBlur, onChange, ref, value }) => (
        <TextArea
          disabled={disabled}
          id={id}
          inputRef={ref}
          invalid={invalid}
          name={name}
          onBlur={onBlur}
          onChange={onChange}
          readOnly={readOnly}
          size={size}
          value={value as string}
          {...props}>
          {children}
        </TextArea>
      )}
    </QuestionTemplate>
  );
}

export default React.memo(QuestionTextArea) as typeof QuestionTextArea;
